import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { EnvironmentService } from "../environment.service";
import { IAliasModel, ICompanyTypeModel, ICompanyModel, IAliasPostRequestModel, IAliasPutRequestModel } from "../../models/product/dto/aliases/product-aliases.model";

@Injectable({
    providedIn: 'root'
})
export class ProductAliasesService {
    fullPath: string;
    constructor(private readonly httpClient: HttpClient, public envService: EnvironmentService) {
        this.fullPath = `${envService.settings.apiUrl}`;
    }

    public getProductAliases(productId: number): Observable<IAliasModel[]> {
        return this.httpClient.get<IAliasModel[]>(`${this.fullPath}/Products/${productId}/partNumberAlias`);
    }

    public addAlias(model: IAliasPostRequestModel): Observable<IAliasModel> {
        return this.httpClient.post<IAliasModel>(`${this.fullPath}/Products/${model.productId}/partNumberAliases`, model);
    }

    public deleteAliases(aliasesForDeletion: number[], productId: number): Observable<boolean> {
        const httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/json' }), body: {
                productId: productId,
                ids: aliasesForDeletion
            }
        };

        return this.httpClient.delete<boolean>(`${this.fullPath}/Products/${productId}/partNumberAliases`, httpOptions);
    }

    public editAlias(model: IAliasPutRequestModel): Observable<IAliasModel> {
        return this.httpClient.put<IAliasModel>(`${this.fullPath}/Products/${model.productId}/partNumberAliases`, model);
    }

    public getCompanyTypes(): Observable<ICompanyTypeModel[]> {
        return this.httpClient.get<ICompanyTypeModel[]>(`${this.fullPath}/Options/companyTypes`);
    }

    public getCompanies(companyTypeCode: string): Observable<ICompanyModel[]> {
        return this.httpClient.get<ICompanyModel[]>(`${this.fullPath}/Options/companies?type=${companyTypeCode}`);
    }
}